export const t = {
  // 首页 nav
  'index': '首頁',
  'index_contactme': '聯繫我們',
  'index_aboutus': '關於我們',
  'index_platform': '商戶平台',
  // 首页 悬浮条
  'index_adv': '服務優勢',
  'index_service': '產品與服務',
  'index_cover': '業務範圍',
  'index_partner': '合作品牌',
  'index_bolo': '成為菠蘿商户',
  // 首页banner 图
  'index_banner_title': '提供微信收款與營銷一體化服務',
  'index_appy_but': '立即申請',
  // 首页 服务优势
  'index_adv_title': 'One Two Go的服務優勢',
  'index_adv_text1_title': '便捷安全的跨境收款',
  'index_adv_text1': '消費者微信支付人民幣，銀行清算後，商家收到港幣，具有金錢服務經營者牌照，資金流轉安全可靠',
  'index_adv_text2_title': '豐富的多渠道線上宣傳',
  'index_adv_text2': '多次與微信、⽀付寶、窮游、螞蜂窩、點評、美團、攜程合作',
  'index_adv_text3_title': '⽤⼾與商⼾間的多維互動',
  'index_adv_text3': '景點、導向、餐飲、購物、娛樂相互導流',
  'index_adv_text4_title': '⾼效的運維服務⽀援',
  'index_adv_text4': '⼯作⼈員24⼩時待命，隨時解決問題，系統定期升級',
  'index_adv_text5_title': '專業技術研發團隊⽀援',
  'index_adv_text5': '專業技術團隊，保障⽀付安全，服務器可以承受數百萬⽤⼾訪問，⼤型營銷事件可以⽀持，與合作夥伴的系統快速融合',
  // 首页商品与服务
  'index_service_title': 'One Two Go提供的產品與服務',
  'index_service_text1_name': '微信⽀付',
  'index_service_text1_namdes': '提供便捷的⽀付⽅式',
  'index_service_text1_desc': '⽅便快捷，簡單掃碼即可⽀付，深受中國旅客喜愛。⽀持多種掃碼⽅式，滿⾜多樣化的需求。',
  'index_service_off_title': '線下微信⽀付',
  'index_service_off_desc': ' 刷卡⽀付、掃碼⽀付、POS機融合',
  'index_service_on_title': '線上微信⽀付',
  'index_service_on_desc': 'PC網站⽀付、⾃助售票機⽀付、⼿機⽀付、公眾號⽀付',
  // service 2
  'index_service_text2_name': '商⼾收款平臺及APP',
  'index_service_text2_namdes': '收款便捷，營收狀況清晰',
  'index_service_text2_desc': '在線⽣成業務報表，分析銷售趨勢，營收狀況⼀⽬了然，更有超級賬號可即時查看多家⾨店銷售情況。⽀持雙重模式收款，⽀付即時收款通知，⽀持多店員同時收款，䋿時查賬、歷史查詢、銷售統計。',
  // service 3
  'index_service_text3_name': '菠蘿PASS',
  'index_service_text3_namdes': '提供全⽅位營銷⼿段',
  'index_service_text3_desc': '為每壹家合作商⼾提供線上編輯與平臺展示，利⽤菠蘿PASS宣傳，同時結合微信公眾號䋿現商⼾品牌推廣',
  // service 4
  'index_service_text4_name': '微信公眾號',
  'index_service_text4_namdes': '提供新型的品牌推廣服務',
  'index_service_text4_desc': '開通連接中國旅客的微信公眾號，品牌可透過公眾號傳遞豐富的內容給⽤⼾，從⽽擴展客⼾市場',
  // service 5
  'index_service_text5_name': '網上商城',
  'index_service_text5_namdes': '提供更⽅便的銷售平臺',
  'index_service_text5_desc': '與公眾號結合，為每個商⼾搭建在線商城，顧客可選購網上售賣商品⾃助下單完成購物，省去繁瑣收單流程。',
  // 业务范围
  'index_scope_title': '全球業務',
  'index_scope_desc': '印尼將在2018第二季度開放。日本、韩国、澳大利亚和新西兰、法国將在2019戰略部署。',
  // 部分合作品牌
  'index_brand_title': '部分合作品牌',
  // input
  'index_bolo_merchant_title': '⽴即成為Bolo商⼾',
  'index_input_company': '請輸入公司名稱',
  'index_input_company_business': '請輸入公司主營業務',
  'index_input_company_address': '請輸入公司詳細地址',
  'index_input_name': '請輸入連絡人',
  'index_input_tel': '請輸入連絡電話',
  'index_input_email': '請輸入連絡郵箱地址',
  'index_input_city': '請輸入所在都市',
  'index_input_desc': '您的留言',
  'index_no_name': '請輸入聯繫人',
  'index_no_tel': '請輸入電話號',
  'index_no_email': '請輸入郵箱',
  'index_no_city': '請輸入城市',
  'index_no_company': '請輸入公司名稱',
  'index_no_company_business': '請輸入公司主營業務',
  'index_no_company_address': '請輸入公司詳細地址',
  'index_email_error': '請填入正確的郵箱格式',
  'index_input_tip_err': '資訊不完整',
  'index_input_tip_succ': '申請成功',
  'index_input_tip_timer': '您提交次數太頻繁，請{0}分鐘後提交',
  'index_input_err_but': '繼續完善資訊',
  'index_input_succ_but': '知道了',
  'index_input_desc_tips': '*申請前請了解以下細則：\n' + '\n' + '菠蘿商戶暫時只接受香港，泰國，馬來西亞當地商戶的支付申請，不接受大陸境內以及個人用戶的申請，其他地區的服務正在拓展中。請填寫公司信息在左邊框內提交審核，信息審核通過後，將會有當地同事上門為您提供服務。 \n' + '\n*如有疑問，請輸入您的留言後提交',

  'index_submit': '提交',
  // 国家
  'france': '法國',
  'china': '中國',
  'japan': '日本',
  'hk': '中国香港',
  'tailland': '泰國',
  'vietnam': '越南',
  'cambodia': '高棉',
  'mala': '馬來西亞',
  'newzea': '紐西蘭',
  'austra': '澳大利亞',
  // 页尾
  'footer_tel_label': '電話',
  'footer_email_label': '郵箱',
  'footer_adress_label': '地址',
  'footer_adress': '香港新界葵涌貨櫃碼頭路88號永得利廣場2座1309室',
  'footer_bolo': '菠蘿商⼾下載',
  'footer_wantu': '玩途⾃由⾏',
  'footer_bolo_pass': '菠蘿PASS服務號',
  // 联系我们
  'connectme_hk_link': '網站',
  'connectme_connect_lab': '聯繫⼈',
  'connectme_connmeth_lab': '聯絡⽅式',
  'connectme_sha': '上海辦事處',
  'connectme_sha_adress': '上海市⻑䌀區中⼭⻄路930號雲都虹橋⼤廈11樓B座',
  'connectme_sz': '深圳辦事處',
  'connectme_sz_adress': '廣東省南山區南山大道南園楓葉大廈5A1',
  'connectme_hk': '⾹港辦事處',
  'connectme_hk_name': '特約服務商',
  'connectme_hk_adress': '香港新界葵涌青山道403-413號匯城集團大廈22樓C室',
  'connectme_hk_service': '戩宸有限公司 Jason Pay Limited',
  'connectme_tail': '泰國辦事處',
  'connectme_taill_adress': 'The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand. 50100',
  'connectme_vietnam': '越南辦事處',
  'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
  'connectme_kuala': '吉隆坡辦事處',
  'connectme_kuala_adress': 'Lot T3-11, KPMG tower, 8 First Avenue, Bandar Utama, 47800 Petaling Jaya, Selangor.',
  'connectme_sabah': '沙巴辦事處',
  'connectme_sabah_adress': 'Unit no 108.First floor, Jalan asia city, Star city, Kota kinabalu, 88000, Sabah, Malaysia',
  // 关于我们
  'aboutus_wantu_title': 'FastPay介紹',
  'aboutus_wantu_p1': 'FastPay 成立於2017年8月，分別在香港、深圳、上海、北京設立辦事處，服務商戶超3000家，業務覆蓋地區包括：香港、泰國、越南、沙巴、澳洲等。 FastPay （母公司為One Two Go Co Limited、One Two Go Systems Limited附屬公司） 最初的主要業務是幫商家接入微信&支付寶線下支付，短短2年多時間，成為支付領域新力軍，之後隨著新零售模式的崛起，逐步切入跨境電商領域，助力商戶跨進新零售時代。',
  'aboutus_partner': '合作夥伴',
  'aboutus_partner_wechat': '微信⽀付',
  'aboutus_partner_alipay': '⽀付寶',
  'aboutus_partner_abc': '中國農業銀⾏',
  'aboutus_partner_ccb': '中國建設銀⾏',
  'aboutus_partner_cmb': '招商銀⾏',
  'aboutus_partner_unpay': '中國銀聯',
  'aboutus_partner_visa': 'VISA',
  'aboutus_partner_master': 'Master card',
  'aboutus_partner_mafengwo': '螞蜂窩',
  'aboutus_partner_qyer': '窮遊',
  'aboutus_partner_tempus': '騰邦',
  'aboutus_partner_jason': 'Jason Pay',
  'aboutus_activity_lab': '過往活動',
  'aboutus_activity_title1': '2015年⽀付寶海外雙⼗⼆狂歡節',
  'aboutus_activity_desc1': '為拓展玩途在新加坡、普吉島、清邁、芭提雅合作的海外第三⽅⽀付市場',
  'aboutus_activity_title2': '2016年泰國餐廳5折吃⼤餐',
  'aboutus_activity_desc2': '玩途與泰國餐廳聯合舉辦空前盛⼤活動——5折吃⼤餐',
  'aboutus_activity_title3': '2017新春三重紅包好禮',
  'aboutus_activity_desc3': '玩途聯⼿泰國旅遊局、微信⽀付、阿貍形象，在江⻄冷舉辦⼤型活動',
  'aboutus_award_title': '我們的獎項',
  'aboutus_year': '年',
  'aboutus_award_p1': '⽀付寶雙⼗⼆海外狂歡節，泰國唯⼀合作夥伴',
  'aboutus_award_p2': '⼿機IOS版被蘋果App store四次評為“新優產品推薦”',
  'aboutus_award_p3': '⼿機的Android版獲得“豌⾖莢設計獎”',
  'aboutus_award_p4': '中國旅業互聯網⾵雲榜最佳海外⽬的地產品預訂平台',
  'aboutus_award_p5': '獲得“微信⽀付合作夥伴2016年度⾏業創新獎”',
  'aboutus_award_p6': '泰國潑⽔節微信⽀付境外媒體招待玩途獨家',
  'aboutus_award_p7': '菠蘿通⼩程序被選為“優秀⼩程序開發代表',
//
  'fast_pay': {
    // 首页 nav
    'index': '首頁',
    'index_contactme': '聯繫我們',
    'index_aboutus': '關於我們',
    'index_platform': '商戶平台',
    // 首页 悬浮条
    'index_adv': '服務優勢',
    'index_service': '產品與服務',
    'index_cover': '業務範圍',
    'index_partner': '合作品牌',
    'index_bolo': '申請支付寶收款',
    // 首页banner 图
    'index_banner_title': 'ALIPAY支付寶商家收款方案',
    'index_appy_but': '香港商戶立即申請支付寶收款',
    // 首页 服务优势
    'index_adv_title': '服務優勢',
    'index_adv_text1_title': '巨大的用戶群',
    'index_adv_text1': '5.2億支付寶實名用戶',
    'index_adv_text2_title': '精準營銷',
    'index_adv_text2': '精準目標客戶折扣信息',
    'index_adv_text3_title': '便捷的支付方式',
    'index_adv_text3': '適用於多種業務場景的支付產品',
    'index_adv_text4_title': '業務分析',
    'index_adv_text4': '了解中國客戶並提供商務建議',
    // 'index_adv_text5_title': '專業技術研發團隊⽀援',
    // 'index_adv_text5': '專業技術團隊，保障⽀付安全，服務器可以承受數百萬⽤⼾訪問，⼤型營銷事件可以⽀持，與合作夥伴的系統快速融合',
    // 首页商品与服务
    'index_service_title': '產品與服務',
    'index_service_text1_name': '支付寶線下收款',
    'index_service_text1_namdes': '包括掃碼支付和二維碼支付',
    'index_service_text1_desc': '適用於免稅店、餐廳、購物店、商場、連鎖店、及其他服務行業，收款的同時支援支付寶人民幣和港幣交易。商戶只需一部智能POS/手機，即可收款',
    'index_service_off_title': '線下微信⽀付',
    'index_service_off_desc': ' 刷卡⽀付、掃碼⽀付、POS機融合',
    'index_service_on_title': '線上微信⽀付',
    'index_service_on_desc': 'PC網站⽀付、⾃助售票機⽀付、⼿機⽀付、公眾號⽀付',
    // service 2
    'index_service_text2_name': '支付寶線上支付',
    'index_service_text2_namdes': '包括Web / Wap /APP支付',
    'index_service_text2_desc': '適用於商戶PC網站、手機WAP / APP，以及線下自助售賣機、POS機系統融合的支付寶交易，均需要商戶具有技術開發能力，因應Fast Pay提供的API文檔完成接駁。',
    // service 3
    'index_service_text3_name': '商⼾收款平臺及APP',
    'index_service_text3_namdes': '收款便捷，營收狀況清晰',
    'index_service_text3_desc': '在線⽣成業務報表，分析銷售趨勢，營收狀況⼀⽬了然，更有超級賬號可即時查看多家⾨店銷售情況。⽀持雙重模式收款，⽀付即時收款通知，⽀持多店員同時收款，實時查賬、歷史查詢、銷售統計。',
    'index_service_text3_name_2': '網上商城',
    'index_service_text3_namdes_2': '提供更方便的銷售平臺',
    'index_service_text3_desc_2': '為每個商戶搭建在線商城，顧客可選購網上售賣商品自助下單完成購物，省去繁瑣收單流程。',
    // 业务范围
    'index_scope_title': '全球業務',
    'index_scope_desc': '印尼將在2018第二季度開放。日本、韩国、澳大利亚和新西兰、法国將在2019戰略部署。',
    // 部分合作品牌
    'index_brand_title': '部分合作品牌',
    // input
    'index_bolo_merchant_title': '⽴即申請支付寶收款',
    'index_input_company': '填寫公司名',
    'index_input_name': '請輸入連絡人',
    'index_input_tel': '請輸入連絡電話',
    'index_input_email': '請輸入連絡郵箱地址',
    'index_input_city': '請輸入所在都市',
    'index_input_desc': '您的留言',
    'index_no_name': '請輸入聯繫人',
    'index_no_tel': '請輸入電話號',
    'index_no_email': '請輸入郵箱',
    'index_no_city': '請輸入城市',
    'index_email_error': '請填入正確的郵箱格式',
    'index_input_tip_err': '資訊不完整',
    'index_input_tip_succ': '申請成功',
    'index_input_err_but': '繼續完善資訊',
    'index_input_succ_but': '知道了',

    'index_submit': '提交',
    // 国家
    'france': '法國',
    'china': '中國',
    'japan': '日本',
    'hk': '中国香港',
    'tailland': '泰國',
    'vietnam': '越南',
    'cambodia': '高棉',
    'mala': '馬來西亞',
    'newzea': '紐西蘭',
    'austra': '澳大利亞',
    // 页尾
    'footer_tel_label': '電話',
    'footer_email_label': '郵箱',
    'footer_adress_label': '地址',
    'footer_adress': '香港新界葵涌貨櫃碼頭路88號永得利廣場2座1309室',
    'footer_bolo': '菠蘿商⼾下載',
    'footer_wantu': '玩途⾃由⾏',
    'footer_bolo_pass': '菠蘿PASS服務號',
    // 联系我们
    'connectme_hk_link': '網站',
    'connectme_connect_lab': '聯繫⼈',
    'connectme_connmeth_lab': '聯絡⽅式',
    'connectme_sha': '上海辦事處',
    'connectme_sha_adress': '上海市⻑䌀區中⼭⻄路930號雲都虹橋⼤廈11樓B座',
    'connectme_sz': '深圳辦事處',
    'connectme_sz_adress': '廣東省南山區南山大道南園楓葉大廈5A1',
    'connectme_hk': '⾹港辦事處',
    'connectme_hk_name': '特約服務商',
    'connectme_hk_adress': '香港九龍長沙灣長裕街8號億京廣場1期15樓1503室',
    'connectme_hk_service': '戬⾠有限公司Jason Pay Limited',
    'connectme_tail': '泰國辦事處',
    'connectme_taill_adress': 'The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand. 50100',
    'connectme_vietnam': '越南辦事處',
    'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
    'connectme_kuala': '吉隆坡辦事處',
    'connectme_kuala_adress': 'Lot T3-11, KPMG tower, 8 First Avenue, Bandar Utama, 47800 Petaling Jaya, Selangor.',
    'connectme_sabah': '沙巴辦事處',
    'connectme_sabah_adress': 'Unit no 108.First floor, Jalan asia city, Star city, Kota kinabalu, 88000, Sabah, Malaysia',
    // 关于我们
    'aboutus_wantu_title': 'FastPay介紹',
    'aboutus_wantu_p1': 'FastPay 成立於2017年8月，分別在香港、深圳、上海、北京設立辦事處，服務商戶超3000家，業務覆蓋地區包括：香港、泰國、越南、沙巴、澳洲等。 One Two Go （母公司為One Two Go Co Limited、One Two Go Systems Limited附屬公司） 最初的主要業務是幫商家接入微信&支付寶線下支付，短短2年多時間，成為支付領域新力軍，之後隨著新零售模式的崛起，逐步切入跨境電商領域，助力商戶跨進新零售時代。',
    'aboutus_partner': '合作夥伴',
    'aboutus_partner_wechat': '微信⽀付',
    'aboutus_partner_alipay': '⽀付寶',
    'aboutus_partner_abc': '中國農業銀⾏',
    'aboutus_partner_ccb': '中國建設銀⾏',
    'aboutus_partner_cmb': '招商銀⾏',
    'aboutus_partner_unpay': '中國銀聯',
    'aboutus_partner_visa': 'VISA',
    'aboutus_partner_master': 'Master card',
    'aboutus_partner_mafengwo': '螞蜂窩',
    'aboutus_partner_qyer': '窮遊',
    'aboutus_partner_tempus': '騰邦',
    'aboutus_partner_jason': 'Jason Pay',
    'aboutus_activity_lab': '過往活動',
    'aboutus_activity_title1': '2015年⽀付寶海外雙⼗⼆狂歡節',
    'aboutus_activity_desc1': '為拓展玩途在新加坡、普吉島、清邁、芭提雅合作的海外第三⽅⽀付市場',
    'aboutus_activity_title2': '2016年泰國餐廳5折吃⼤餐',
    'aboutus_activity_desc2': '玩途與泰國餐廳聯合舉辦空前盛⼤活動——5折吃⼤餐',
    'aboutus_activity_title3': '2017新春三重紅包好禮',
    'aboutus_activity_desc3': '玩途聯⼿泰國旅遊局、微信⽀付、阿貍形象，在江⻄冷舉辦⼤型活動',
    'aboutus_award_title': '我們的獎項',
    'aboutus_year': '年',
    'aboutus_award_p1': '⽀付寶雙⼗⼆海外狂歡節，泰國唯⼀合作夥伴',
    'aboutus_award_p2': '⼿機IOS版被蘋果App store四次評為“新優產品推薦”',
    'aboutus_award_p3': '⼿機的Android版獲得“豌⾖莢設計獎”',
    'aboutus_award_p4': '中國旅業互聯網⾵雲榜最佳海外⽬的地產品預訂平台',
    'aboutus_award_p5': '獲得“微信⽀付合作夥伴2016年度⾏業創新獎”',
    'aboutus_award_p6': '泰國潑⽔節微信⽀付境外媒體招待玩途獨家',
    'aboutus_award_p7': '菠蘿通⼩程序被選為“優秀⼩程序開發代表'
  }
};



// WEBPACK FOOTER //
// ./src/_components/i18n/tw.js